export default function backendToInputDate(mmddyyyy) {
  if (!mmddyyyy) return "";
  const [mm, dd, yyyy] = mmddyyyy.split("-");
  return `${yyyy}-${mm.padStart(2,"0")}-${dd.padStart(2,"0")}`;
}
